import $ from 'jquery';

class Header {
    constructor() {
        this.headerHandle();
        this.subMenuMobileHandle();
        this.handleModal();

        this.handleSearch();
    }

    handleSearch(){
        const header = document.querySelector('.header');
        if (!header) return;
        const btn = header.querySelector('.btn-search-header');
        if (!btn){ return; }

        const formSearchHeader = header.querySelector('.form-search-header');
        const menuHeaderNav = header.querySelector('.menu-header-nav');

        btn.addEventListener('click', (e) => {
            e.preventDefault();

            btn.classList.toggle('toggle');

            if (btn.classList.contains('toggle')){
                formSearchHeader.style.display = "";
                menuHeaderNav.style.opacity = "0";
                menuHeaderNav.style.pointerEvent = "none";
            }else{
                formSearchHeader.style.display = "none";
                menuHeaderNav.style.opacity = "1";
                menuHeaderNav.style.pointerEvent = "";
            }
        })
    }

    headerHandle(){
        const header = document.querySelector('.header');
        if (!header) return;
        let debounceTimeout;

        window.addEventListener('scroll', ()=>{
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(()=> {
                if (window.scrollY > 100){
                    header.classList.add('scrolling');
                } else{
                    header.classList.remove('scrolling');
                }
            }, 300);
        })
    }

    subMenuMobileHandle() {
        const headerMenuMb = document.querySelector('.main-menu-mobile');
        if (!headerMenuMb) { return; }
        if (window.innerWidth > 1023){return;}

        const menuItems = headerMenuMb.querySelectorAll('.menu-item');
        menuItems.forEach(menuItem => {
            menuItem.addEventListener('click', function (e) {
                e.stopPropagation();

                const hrefParent = e.target.href;
                if (!hrefParent || hrefParent === '#' || hrefParent === 'javascript:void(0)') {
                } else {
                    return true;
                }

                e.preventDefault();
                this.handleSubmenu(menuItem);
            }.bind(this))
        });
    }

    handleSubmenu(menuItem){
        const submenu = menuItem.querySelector('.sub-menu');
        if (submenu) {
            menuItem.classList.toggle('showed');
            if (menuItem.classList.contains('showed')) {
                this.jquerySlideDown(submenu);
            } else {
                this.jquerySlideUp(submenu);
            }
        }
    }

    handleModal() {
        const ariaModal = document.querySelectorAll('.js-aria-modal');
        ariaModal.forEach((item) => {
            let jsOpened = item.querySelector('.jsopened');
            let modal = document.querySelector(`[data-modal-popup="${item.dataset.modal}"]`);
            if (!modal) return;

            let jsClosed = modal.querySelectorAll('.jsclosed');
            if (!jsOpened) {
                return;
            }
            // modal.style.display = "none";

            jsOpened.addEventListener('click', function (e) {
                e.preventDefault();
                jsOpened.classList.toggle('showed');

                if (jsOpened.classList.contains('showed')){
                    modal.style.display = "block";
                }else{
                    modal.style.display = "none";
                }
            })

            jsClosed.forEach((close) => {
                close.addEventListener('click', function (e) {
                    e.preventDefault();
                    jsOpened.classList.remove('showed');
                    modal.style.display = "none";
                })
            })

            const links = modal.querySelectorAll('a[href*="#"]');
            links.forEach(function(anchor) {
                anchor.addEventListener('click', (e) => {
                    jsOpened.classList.remove('showed');
                    modal.style.display = "none";
                })
            })
        })
    }

    jquerySlideDown(element, duration = 250) {
        $(element).stop(true, true).slideDown(duration);
    }

    jquerySlideUp(element, duration = 250) {
        $(element).stop(true, true).slideUp(duration);
    }
}

export default Header;